export const FileUploadIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg
      width="23"
      height="19"
      viewBox="0 0 23 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9371 2.87491L10.0622 0H0V18.6869H22.9993V2.87491H12.9371ZM11.4994 7.90686L16.5305 12.938H12.9368V18.6878H10.0619V12.938H6.46829L11.4994 7.90686Z"
        fill="currentColor"
      />
    </svg>
  )
}
